import { combineReducers } from 'redux';

import mailThreads from './mailThreads/reducer';
import mailThreadMessages from './mailThreadMessages/reducer';

export default combineReducers({
  mailThreads,
  mailThreadMessages
});



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/paging/reducer.js
 **/